import { render } from "./AlertCircle.vue?vue&type=template&id=247a9cc1"
import script from "./AlertCircle.vue?vue&type=script&lang=js"
export * from "./AlertCircle.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__